export const getVariantPath = ({
  atomicType,
  componentId,
  variantName,
  field,
  additionalKeys = [],
}) => {
  const additionalKeysObjectPath = additionalKeys.join('.')

  const isBasePath = !variantName
  const fieldPath = field ? `.${field}` : ''

  if (isBasePath) {
    const basePath = `${atomicType}.${componentId}.base${fieldPath}${additionalKeysObjectPath}`
    return basePath
  }

  const variantPath = `${atomicType}.${componentId}.variants.${variantName}${fieldPath}${additionalKeysObjectPath}`
  return variantPath
}
